import { ScrollNavigationItemWrapper } from './styles';
import { ScrollNavigationItemProps } from './types';

const ScrollNavigationItem = ({ children, id }: ScrollNavigationItemProps) => {
  return <ScrollNavigationItemWrapper id={id}>{children}</ScrollNavigationItemWrapper>;
};

export default ScrollNavigationItem;
